import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Dotdotdot from 'react-dotdotdot';
import classNames from 'classnames';

const READER_MS_DELAY = 2300;

const TileTitle = ({
  isDisabled,
  isRedirect,
  isSeriesDetailAvailable,
  isUpcoming,
  link,
  onClick,
  Style,
  target,
  title,
  titleLines,
}) => {
  const titleRef = useRef(null);
  useEffect(() => {
    const ref = setTimeout(() => {
      titleRef.current.ariaLabel = titleLines ? title?.props?.children?.props.children[0] : title;
      titleRef.current.ariaHidden = false;
    }, READER_MS_DELAY);
    return () => {
      clearTimeout(ref);
    };
  }, [title, titleLines]);

  if (!title || title.length === 0) return null;
  let titleLink = link;
  const titleClasses = [Style.title];
  const titleClass = isDisabled ? classNames([Style.title, Style.disabled]) : Style.title;
  const text = titleLines ? (
    <div className={Style.ellipsisTitle} data-test="dotdotdot-container">
      <Dotdotdot clamp={titleLines}>{title}</Dotdotdot>
    </div>
  ) : (
    title
  );
  if (!link || isDisabled) return <div className={titleClass}>{text}</div>;
  if (isRedirect) {
    titleLink = null;
    titleClasses.push(Style.redirectLink);
  }

  if (isUpcoming && isSeriesDetailAvailable === false) {
    titleLink = null;
  } else {
    titleClasses.push(Style.titleV2);
  }

  function linkHander(e) {
    onClick(e);
  }

  return (
    <Link
      to={titleLink}
      target={target}
      onClick={linkHander}
      className={classNames(titleClasses)}
      tab-index="0"
      ref={titleRef}
      aria-hidden="true"
      aria-label={text}
    >
      {text}
    </Link>
  );
};

export default TileTitle;

TileTitle.propTypes = {
  isDisabled: PropTypes.bool,
  isRedirect: PropTypes.bool,
  isSeriesDetailAvailable: PropTypes.bool,
  isUpcoming: PropTypes.bool,
  link: PropTypes.string,
  onClick: PropTypes.func,
  Style: PropTypes.shape({}).isRequired,
  target: PropTypes.string,
  title: PropTypes.string,
  titleLines: PropTypes.number,
};
